export default {
    title: 'Zisti viac o formáteri',
    add: {
        title: 'Vloženie JSON do JXformatter',
        text1: 'Nakopíruj tvoj JSON do textového pola a formatter prehodnotí tvoj JSON.',
        text2: 'Ak je validný, môžeš ho naformátovať kliknutím na tlačítko „Spusti“. V opačnom prípade ti zobrazí error hlášku s popisom chyby.',
        text3: 'Ak sa v naformátovanom JSONe nachádza STRINGová property, ktorá je validný JSON, tak danú hodnotu naformátuje.'
    },
    generated: {
        title: 'Vygenerovaný JSON tree poskytuje nasledujúce možnosti:',
        openClose: {
            title: 'rozbaľovanie a zbaľovanie všetkých položiek naraz'
        },
        edit: {
            title: 'editovanie jednotlivých property dvojklikom na názov alebo hodnotu'
        },
        addnew: {
            title: 'pridávanie nových property v menu "Nastavenia" cez "Pridať podpoložku"'
        },
        editMenu: {
            title: 'editovanie jednotlivých položiek v nastaveni konkrétnej položky'
        },
        propType: {
            title: 'pri výbere typu property (object alebo array) je možné vybrať výstupný formát',
            text: 'a to buď typ property alebo string.'
        },
        propOutputType: {
            title: 'pri stringu je výstupná property konvertovaná do stringu',
            text: 'tak ako property "dataString" a to bud typ property alebo string v pripade vyberu "string" je vystupna property konvertovana do stringu tak ako property "dataString"\''
        },
        copy: {
            title: 'kopírovanie vybraného nodu alebo premennej',
            text: 'a jej prilepenie je možné iba do objektu alebo array',
        }
    },
    search: {
        title: 'Fulltextové vyhľadávanie',
        text: 'Nad JSON tree je možné vyhľadať názov property alebo jej hodnotu.'
    },
    output: {
        title: 'Výstupný formát',
        text: 'Checkbox pri jednotlivých hodnotách umožňuje spätnú konverziu vybraných hodnôt do výstupného sformátovaného JSON tvaru.'
    }
}
